import React, { Fragment, useEffect, useRef, useState } from "react"
import { toast } from "react-toastify"

import { validateStockTransferContents } from "utils"
import { Button, ConfirmationModal, OrderStockValidationResultModal } from "components"
import { resolveStockTransferRequestDiscrepancy } from "services"
import classes from "./StrrdFooter.module.scss"

const StrrdFooter = (props) => {
  const {
    resolveNote,
    resolvedItems,
    stockTransferRequest,
    setStockTransferRequests,
    setShowStockTransferResolveModal
  } = props

  const [sending, setSending] = useState(false)
  const [problematicItems, setProblematicItems] = useState([])
  const [openReceiveConfirmationModal, setOpenReceiveConfirmationModal] = useState(false)
  const [openOrderValidationResultModal, setOpenOrderValidationResultModal] = useState(false)

  const unmount = useRef(false)

  const validateReductionItems = async (reductionItems) => {
    const problematicItems =
      await validateStockTransferContents(
        reductionItems,
        stockTransferRequest.sourceBranchId
      )

    if (problematicItems.length === 0) return true

    setProblematicItems(
      problematicItems
    )

    setOpenOrderValidationResultModal(true)

    return false
  }


  const handleResolve = async () => {
    setSending(true)

    const reductionItems =
      resolvedItems.filter(ri =>
        Number(ri.reductionFromSourceQuantity) > 0
      )

    const haveReductionItems = reductionItems > 0

    if (haveReductionItems) {

      const result =
        await validateReductionItems(reductionItems)

      if (!result) return setSending(false)
    }

    const items =
      resolvedItems.map(resolvedItem => ({
        foodId: resolvedItem.foodId,
        optionId: resolvedItem.optionId,
        returnedToDestinationQuantity: Number(resolvedItem.returnedToDestinationQuantity),
        returnedToSourceQuantity: Number(resolvedItem.returnedToSourceQuantity),
        reductionFromSourceQuantity: Number(resolvedItem.reductionFromSourceQuantity),
        lossQuantity: Number(resolvedItem.lossQuantity)
      }))

    try {
      const response =
        await resolveStockTransferRequestDiscrepancy(
          stockTransferRequest._id,
          {
            resolveNote,
            resolvedItems: items
          }
        )

      if (unmount.current) return

      setStockTransferRequests(prev =>
        prev.map(str =>
          str._id === response._id
            ? { ...str, ...response }
            : str
        )
      )

      setShowStockTransferResolveModal(false)

      setOpenReceiveConfirmationModal(false)
    } catch (err) {
      console.log(err)

      setSending(false)

      toast.error("عملیات انجام نشد")
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <Fragment>
      <div className={classes["footer"]}>
        <Button
          color="success"
          onClick={() => setOpenReceiveConfirmationModal(true)}
        >
          ارسال گزارش
        </Button>
      </div>
      <ConfirmationModal
        loading={sending}
        title="آیا می خواهید این گزارش را ارسال کنید ؟"
        show={openReceiveConfirmationModal}
        onConfirm={handleResolve}
        onHide={() => setOpenReceiveConfirmationModal(false)}
      />
      <OrderStockValidationResultModal
        problematicItems={problematicItems}
        openOrderValidationResultModal={openOrderValidationResultModal}
        setOpenOrderValidationResultModal={setOpenOrderValidationResultModal}
      />
    </Fragment>
  )
}

export default StrrdFooter